import { render } from "./TaskLinkedToSearch.vue?vue&type=template&id=b0702964&scoped=true"
import script from "./TaskLinkedToSearch.vue?vue&type=script&lang=js"
export * from "./TaskLinkedToSearch.vue?vue&type=script&lang=js"

import "./TaskLinkedToSearch.vue?vue&type=style&index=0&id=b0702964&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0702964"]])

export default __exports__